<template>
    <nav class="w-full col-span-1 mb-4 ">
        <ul
            class="bg-white border border-gray-300 divide-y divide-gray-300 rounded-md md:flex md:divide-y-0"
        >
            <li
                v-for="(step, index) in steps"
                :key="index"
                class="relative md:flex-1 md:flex"
            >
                <!-- <router-link
          :disabled="require && !step.isCompleted"
          :event="require && !step.isCompleted ? 'click' : ''"
          :to="{ name: step.path }"
          class="flex items-center w-full group"
                >-->
                <component
                    :is="router(step)"
                    :to="{ name: step.path }"
                    class="flex items-center w-full group"
                >
                    <div
                        class="flex items-center px-6 py-4 space-x-4 text-sm font-medium leading-5 outline-none"
                    >
                        <div
                            class="flex items-center justify-center flex-shrink-0 w-10 h-10 transition duration-150 ease-in-out rounded-full outline-none"
                            :class="{
                                'bg-blue-600 group-hover:bg-blue-800':
                                    step.isCompleted
                            }"
                        >
                            <svg
                                v-if="step.isCompleted"
                                class="w-6 h-6 text-white"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <div
                                v-if="!step.isCompleted"
                                :class="{
                                    'flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-blue-600 rounded-full':
                                        step.current,
                                    'flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400 transition ease-in-out duration-150':
                                        !step.current && !step.isCompleted
                                }"
                            >
                                <p
                                    :class="{
                                        'text-blue-600': step.current,
                                        'text-gray-500 group-hover:text-gray-900 transition ease-in-out duration-150':
                                            !step.current && !step.isCompleted
                                    }"
                                >
                                    0{{ index + 1 }}
                                </p>
                            </div>
                        </div>
                        <p
                            :class="{
                                'text-sm leading-5 font-medium text-gray-900':
                                    step.isCompleted,
                                'text-sm leading-5 font-medium text-blue-600':
                                    step.current,
                                'text-sm leading-5 font-medium text-gray-500 group-hover:text-gray-900 transition ease-in-out duration-150':
                                    !step.current && !step.isCompleted
                            }"
                        >
                            {{ step.title }}
                        </p>
                    </div>
                </component>
                <!-- </router-link> -->

                <div
                    v-if="steps.length - 1 > index"
                    class="absolute top-0 right-0 hidden w-5 h-full md:block"
                >
                    <svg
                        class="w-full h-full text-gray-300"
                        viewBox="0 0 22 80"
                        fill="none"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M0 -2L20 40L0 82"
                            vector-effect="non-scaling-stroke"
                            stroke="currentcolor"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        steps: {
            type: Array,
            required: true
        },
        require: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        router() {
            return step => {
                if (this.require && !step.isCompleted) return "template";
                return "router-link";
            };
        }
    }
};
</script>

<style></style>
